// path: src/modules/secured/modules/companies/containers/CompaniesListContainer.js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { deleteCompany } from 'companies/actions';
import { verifyToken } from 'auth/actions';

import { addGrowlMessage, clearGrowlMessages } from 'messages/actions';

import { setCompany, setSubcompany } from 'auth/actions';
import { resetSubcompanies } from 'subcompanies/actions';
import { getVisibleCompanies } from 'companies/selectors';

import * as Common from 'common/components';
import * as Companies from 'companies/components';
import CompanyContainer from 'companies/containers/CompanyContainer';

class CompaniesListContainer extends Component {
  state = { isOpenedDeleteModal: false, companyToDelete: null };

  static propTypes = {
    companies: PropTypes.arrayOf(PropTypes.object).isRequired,
    user: PropTypes.object,
    isRoot: PropTypes.bool,
    addGrowlMessage: PropTypes.func.isRequired,
    clearGrowlMessages: PropTypes.func.isRequired,
    deleteCompany: PropTypes.func.isRequired,
    setCompany: PropTypes.func.isRequired,
    setSubcompany: PropTypes.func.isRequired,
    verifyToken: PropTypes.func.isRequired,
    resetSubcompanies: PropTypes.func.isRequired,
    history: PropTypes.object,
  };

  componentWillMount = () => {
    this.props.resetSubcompanies();
    this.props.setSubcompany(null);
    this.props.setCompany(null);
  };

  handleDeleteCompany = (e, company) => {
    this.setState({ isOpenedDeleteModal: true, companyToDelete: company });
  };

  handleCloseDeleteModal = (e) => {
    this.setState({ isOpenedDeleteModal: false, companyToDelete: null });
  };

  handleAcceptDeleteModal = (e) => {
    this.props
      .deleteCompany(this.state.companyToDelete.id)
      .then(({ value }) => {
        this.props.addGrowlMessage(value.message, 'success', 'common.success');
        this.props.verifyToken();
      })
      .catch((err) => this.props.addGrowlMessage(err.message, 'danger', 'common.error'));
    this.setState({ isOpenedDeleteModal: false, companyToDelete: null });
  };

  // Reservado para cuando exista el módulo de facturación/renovación
  handleGoToBilling = () => {
    // this.props.history.push('/billing');
  };

  formatDate = (date) => {
    if (!date) return '-';
    const d = new Date(date);
    return d.toLocaleDateString('es-MX', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
    });
  };

  render = () => {
    const { companies, user, isRoot } = this.props;

    const hasCompanies = companies && companies.length > 0;
    const planStatus = (user && user.planStatus) || {};
    const hasExpiredCompany = !!planStatus.hasExpiredCompany;
    const expiredCompany = planStatus.expiredCompany || null;

    const companyLabel =
      (expiredCompany && (expiredCompany.shortname || expiredCompany.name)) ||
      'tu compañía';

    const salesAgentName = expiredCompany && expiredCompany.salesAgentName;
    const salesAgentEmail =
      (expiredCompany && expiredCompany.salesAgentEmail) || 'ventas@tusistema.com';

    const mailtoHref = `mailto:${salesAgentEmail}?subject=Renovación de plan - ${encodeURIComponent(
      companyLabel
    )}`;

    const endDate = expiredCompany && expiredCompany.endDate;
    const initDate = expiredCompany && expiredCompany.initDate;
    const formattedEndDate = this.formatDate(endDate);
    const formattedInitDate = this.formatDate(initDate);

    const adminsLimit = expiredCompany && expiredCompany.adminsLimit;
    const assetsLimit = expiredCompany && expiredCompany.assetsLimit;
    const filesPerAsset = expiredCompany && expiredCompany.filesPerAsset;
    const sizePerFile = expiredCompany && expiredCompany.sizePerFile;
    const isDemo = expiredCompany && expiredCompany.isDemo;

    const planTypeLabel = isDemo ? 'Demo' : 'Plan contratado';
    const planTypeClass = isDemo
      ? 'plan-expired-plan-demo'
      : 'plan-expired-plan-paid';

    return (
      <Common.PageWrapper fluid={true}>
        <Companies.ListHeader canAdd={isRoot} />

        {/* Vista cuando no hay compañías activas pero sí hay plan vencido */}
        {!hasCompanies && hasExpiredCompany && (
          <div className="plan-expired-wrapper">
            <div className="plan-expired-card">
              {/* Icono circular */}
              <div className="plan-expired-icon">
                <i className="fa fa-lock plan-expired-icon-lock" />
              </div>

              {/* Pill de estado */}
              <div className="plan-expired-badge">PLAN VENCIDO</div>

              <h3 className="plan-expired-title">Tu plan ha vencido</h3>

              <p className="plan-expired-text">
                El plan asociado a <strong>{companyLabel}</strong> se encuentra
                vencido, por lo que no es posible mostrar tus compañías en este
                momento.
              </p>
              <p className="plan-expired-text-secondary">
                Tu asesor asignado es{' '}
                {salesAgentName ? (
                  <strong>{salesAgentName}</strong>
                ) : (
                  'nuestro equipo comercial'
                )}
                . Puedes renovar tu suscripción en línea desde el módulo de
                facturación o ponerte en contacto con tu asesor para recibir apoyo.
              </p>

              {/* Resumen de la cuenta */}
              <div className="plan-expired-summary">
                <div className="plan-expired-summary-title">
                  Resumen de tu cuenta
                </div>

                <div className="plan-expired-summary-grid">
                  {/* Compañía */}
                  <div className="plan-expired-summary-item">
                    <div className="plan-expired-summary-label">Compañía</div>
                    <div className="plan-expired-summary-value">
                      {companyLabel}
                    </div>
                  </div>

                  {/* Tipo de plan */}
                  <div className="plan-expired-summary-item">
                    <div className="plan-expired-summary-label">Tipo de plan</div>
                    <div
                      className={`plan-expired-summary-value ${planTypeClass}`}
                    >
                      {planTypeLabel}
                    </div>
                  </div>

                  {/* Vigencia */}
                  <div className="plan-expired-summary-item plan-expired-summary-item-large">
                    <div className="plan-expired-summary-label">
                      Vigencia del plan
                    </div>
                    <div className="plan-expired-summary-subvalue">
                      {formattedInitDate} &nbsp;–&nbsp;
                      <span className="plan-expired-summary-date-end">
                        {formattedEndDate}
                      </span>
                    </div>
                  </div>

                  {/* Límite de administradores */}
                  <div className="plan-expired-summary-item">
                    <div className="plan-expired-summary-label">
                      Límite de administradores
                    </div>
                    <div className="plan-expired-summary-value">
                      {adminsLimit != null ? adminsLimit : '-'}
                    </div>
                  </div>

                  {/* Límite de activos */}
                  <div className="plan-expired-summary-item">
                    <div className="plan-expired-summary-label">
                      Límite de activos
                    </div>
                    <div className="plan-expired-summary-value">
                      {assetsLimit != null
                        ? assetsLimit.toLocaleString('es-MX')
                        : '-'}
                    </div>
                  </div>

                  {/* Archivos por activo / Tamaño por archivo */}
                  <div className="plan-expired-summary-item plan-expired-summary-item-large">
                    <div className="plan-expired-summary-label">
                      Archivos por activo / Tamaño
                    </div>
                    <div className="plan-expired-summary-subvalue">
                      {filesPerAsset != null ? filesPerAsset : '-'} archivos,&nbsp;
                      {sizePerFile != null ? `${sizePerFile} MB` : '-'}
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA principal + secundarios */}
              <div className="plan-expired-actions">
                {/* Botón principal: Renovar plan (deshabilitado por ahora) */}
                <button
                  type="button"
                  className="btn plan-expired-primary-btn plan-expired-primary-btn-disabled"
                  disabled
                  title="Esta opción estará disponible próximamente"
                >
                  Renovar plan (próximamente)
                </button>

                {/* Botón secundario: Contactar a ventas / asesor */}
                <a
                  href={mailtoHref}
                  className="btn plan-expired-secondary-btn"
                >
                  {salesAgentName ? 'Contactar a tu asesor' : 'Contactar a ventas'}
                </a>

                {/* Acción terciaria: reintentar (link, no botón visual) */}
                <button
                  type="button"
                  className="plan-expired-tertiary-btn"
                  onClick={() => window.location.reload()}
                >
                  Volver a intentar más tarde
                </button>
              </div>

              <p className="plan-expired-footnote">
                Si crees que esto es un error, por favor contacta a soporte técnico.
              </p>
            </div>
          </div>
        )}

        {/* Vista normal cuando sí hay compañías activas */}
        {hasCompanies &&
          companies.map((company) => (
            <CompanyContainer
              key={company.id}
              company={company}
              handleDelete={this.handleDeleteCompany}
            />
          ))}

        <Companies.DeleteModal
          company={this.state.companyToDelete}
          handleClose={this.handleCloseDeleteModal}
          handleAccept={this.handleAcceptDeleteModal}
          isOpened={this.state.isOpenedDeleteModal}
        />
      </Common.PageWrapper>
    );
  };
}

const mapStateToProps = (state) => ({
  companies: getVisibleCompanies(state),
  user: state.auth && state.auth.user,
  isRoot: state.auth && state.auth.user && state.auth.user.root,
});

const mapDispatchToProps = {
  addGrowlMessage,
  clearGrowlMessages,
  deleteCompany,
  setCompany,
  setSubcompany,
  verifyToken,
  resetSubcompanies,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CompaniesListContainer));



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/containers/CompaniesListContainer.js